import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Department } from '../models/user.model';
import { ApiService } from '../../core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class HsformService {
  private departmentCode: string;
  private selectedDept: BehaviorSubject<Department> = new BehaviorSubject<Department>(null);
  constructor(private apiService: ApiService) { }

  getDepartmentCode(): string {
    return this.departmentCode;
  }

  setDepartmentCode(departmentCode: string): void {
    this.departmentCode = departmentCode;
  }

  getSelectedDept(): BehaviorSubject<Department> {
    return this.selectedDept;
  }

  triggerSelectedDept(department: Department) {
    this.selectedDept.next(department);
  }

  getUserCompliance(): Observable<boolean> {
    return this.apiService.createGetServiceCall<boolean>(
      this.apiService.getBaseUrl() + 'user-properties/compliance/',
      ''
    );
  }

  updateUserCompliance(): Observable<boolean> {
    return this.apiService.createPostServiceCallRawJson<boolean>(
      this.apiService.getBaseUrl() + 'user-properties/compliance/',
      ''
    );
  }


}
